import dayjs from 'dayjs'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { DATE_FORMAT } from '@/shared/utils/constants'

export const useCalendarStore = defineStore('calendar', () => {
  const now = dayjs.tz()

  const selectedDate = ref(now.format(DATE_FORMAT))
  const _selectedYear = ref(now.year())
  const _selectedMonth = ref(now.month())

  const selectedYear = computed({
    get: () => _selectedYear.value,
    set: (v) => { _selectedYear.value = Number(v) },
  })
  const selectedMonth = computed({
    get: () => _selectedMonth.value,
    set: (v) => { _selectedMonth.value = Number(v) },
  })

  const selectedEventName = ref<string>('')
  const selectedEventType = ref<string>('')

  return {
    selectedDate,
    selectedMonth,
    selectedYear,
    selectedEventName,
    selectedEventType,
  }
})
